"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class SiteSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      mobileExpanded: false,
      hover: false,
      americas: false,
      europe: false,
      asia: false,
      africa: false
    };
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.handleHover = this.handleHoverEvent.bind(this);
    this.toggleAmericas = this.toggleAmericas.bind(this);
    this.toggleEurope = this.toggleEurope.bind(this);
    this.toggleAsia = this.toggleAsia.bind(this);
    this.toggleAfrica = this.toggleAfrica.bind(this);
  }
  toggleExpanded() {
    const currentState = this.state.expanded;
    this.setState({
      expanded: !currentState
    });
  }
  handleHoverEvent() {
    this.setState({
      hover: !this.state.hover
    });
  }
  toggleAmericas() {
    this.setState({
      americas: !this.state.americas
    });
  }
  toggleEurope() {
    this.setState({
      europe: !this.state.europe
    });
  }
  toggleAsia() {
    this.setState({
      asia: !this.state.asia
    });
  }
  toggleAfrica() {
    this.setState({
      africa: !this.state.africa
    });
  }
  render() {
    const siteSelector = {
      height: '52px',
      width: '30px',
      overflow: 'hidden',
      margin: '23px 5px 0 5px',
      float: 'right',
      backgroundImage: 'url("https://www.concur.com/sites/all/modules/custom_concur/concur_site_selector/images/' + this.props.lang.substring(3) + '.svg")',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '30px'
    };
    const siteSelectorButton = {
      height: '52px',
      width: '30px',
      overflow: 'hidden',
      float: 'right',
      border: 'none',
      position: 'absolute'
    };
    const siteSelectorExpanded = {
      height: '52px',
      width: '30px',
      margin: '23px 5px 0 5px',
      float: 'right',
      backgroundImage: 'url("https://www.concur.com/sites/all/modules/custom_concur/concur_site_selector/images/' + this.props.lang.substring(3) + '.svg")',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '30px',
      borderBottom: '4px solid #f0ab00',
      overflow: 'auto'
    };
    const siteSelectorDropdown = {
      maxHeight: '0',
      height: 'auto',
      top: '75px',
      backgroundColor: '#333',
      transition: 'all 0.25s ease-in-out',
      overflow: 'hidden',
      cursor: 'default',
      width: '688px',
      position: 'absolute',
      right: '75px'
    };
    const siteSelectorDropdownExpanded = {
      maxHeight: '100vh',
      height: 'auto',
      top: '75px',
      backgroundColor: '#333',
      transition: 'all 0.25s ease-in-out',
      overflow: 'hidden',
      cursor: 'default',
      width: '688px',
      position: 'absolute',
      right: '75px'
    };
    const siteSelectorDropdownMobile = {
      maxHeight: '0',
      height: 'auto',
      top: '75px',
      backgroundColor: '#333',
      transition: 'all 0.25s ease-in-out',
      overflow: 'hidden',
      cursor: 'default',
      width: '688px',
      position: 'absolute',
      right: '75px'
    };
    const siteSelectorDropdownExpandedMobile = {
      top: '75px',
      backgroundColor: '#333',
      overflow: 'hidden',
      cursor: 'default',
      width: '60vw',
      position: 'absolute',
      right: '-15px',
      transition: 'none',
      height: '1400px'
    };
    const regionHeader = {
      color: '#f0ab00',
      textTransform: 'uppercase',
      fontSize: '19px',
      margin: '10px 0 15px',
      fontWeight: '100',
      paddingBottom: '5px'
    };
    const regionHeaderMobile = {
      color: '#fff',
      textTransform: 'uppercase',
      fontSize: '19px',
      margin: '10px 0 15px',
      fontWeight: '100',
      paddingBottom: '5px'
    };
    const regionHeaderMobile2 = {
      color: '#fff',
      textTransform: 'uppercase',
      fontSize: '19px',
      margin: '10px 0 15px',
      fontWeight: '100',
      paddingBottom: '5px',
      borderBottom: '2px solid #f0ab00'
    };
    const linkStyles = {
      color: '#fff',
      display: 'block',
      fontSize: '14px',
      marginBottom: '20px',
      fontWeight: '100',
      textDecoration: 'underline'
    };
    const divContainer = {
      maxHeight: '0',
      height: 'auto',
      overflow: 'hidden',
      transition: 'all 0.25s ease-in-out'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "site-selector",
      style: this.state.expanded ? siteSelectorExpanded : siteSelector,
      onMouseEnter: this.handleHover,
      onMouseLeave: this.handleHover
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: siteSelectorButton,
      onClick: this.toggleExpanded
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "site-selector-dropdown",
      style: this.props.isMobile ? this.state.expanded ? siteSelectorDropdownExpandedMobile : siteSelectorDropdownMobile : this.state.expanded ? siteSelectorDropdownExpanded : siteSelectorDropdown
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 flush-xs"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "region-header",
      style: this.props.isMobile ? this.state.americas ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
      onClick: this.toggleAmericas
    }, "Americas"), /*#__PURE__*/_react.default.createElement("div", {
      style: this.props.isMobile ? this.state.americas ? {} : divContainer : {}
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com"
    }, "United States (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.ca"
    }, "Canada (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.ca/fr"
    }, "Canada (Fran\xE7ais)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.mx"
    }, "M\xE9xico (Espa\xF1ol)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.br"
    }, "Brasil (Portugu\xEAs)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.ar"
    }, "Argentina (Espa\xF1ol)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.co"
    }, "Colombia (Espa\xF1ol)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.cl"
    }, "Chile (Espa\xF1ol)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.pe"
    }, "Peru (Espa\xF1ol)")), /*#__PURE__*/_react.default.createElement("p", {
      className: "region-header",
      style: this.props.isMobile ? this.state.africa ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
      onClick: this.toggleAfrica
    }, "Middle East and Africa"), /*#__PURE__*/_react.default.createElement("div", {
      style: this.props.isMobile ? this.state.africa ? {} : divContainer : {}
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.co.za"
    }, "South Africa (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.ae"
    }, "United Arab Emirates (English)"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "region-header",
      style: this.props.isMobile ? this.state.europe ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
      onClick: this.toggleEurope
    }, "Europe"), /*#__PURE__*/_react.default.createElement("div", {
      style: this.props.isMobile ? this.state.europe ? {} : divContainer : {}
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.co.uk"
    }, "United Kingdom (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.fr"
    }, "France (Fran\xE7ais)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.de"
    }, "Deutschland (Deutsch)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.it"
    }, "Italia (Italiano)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.nl"
    }, "Nederlands (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.se"
    }, "Sweden (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.dk"
    }, "Denmark (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.fi"
    }, "Finland (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.be"
    }, "Belgium (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.es"
    }, "Espa\xF1a (Espa\xF1ol)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.no"
    }, "Norway (English)"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "region-header",
      style: this.props.isMobile ? this.state.asia ? regionHeaderMobile2 : regionHeaderMobile : regionHeader,
      onClick: this.toggleAsia
    }, "Asia Pacific"), /*#__PURE__*/_react.default.createElement("div", {
      style: this.props.isMobile ? this.state.asia ? {} : divContainer : {}
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.au"
    }, "Australia (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.cn"
    }, "\u4E2D\u56FD\uFF08\u7B80\u4F53\u4E2D\u6587)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.hk"
    }, "Hong Kong SAR of China (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.co.in"
    }, "India (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.co.jp"
    }, "\u65E5\u672C\uFF08\u65E5\u672C\u8A9E)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.kr"
    }, "\uB300\uD55C\uBBFC\uAD6D (\uD55C\uAD6D\uC5B4)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.com.sg"
    }, "Singapore (English)"), /*#__PURE__*/_react.default.createElement("a", {
      style: linkStyles,
      href: "https://www.concur.tw"
    }, "\u4E2D\u570B\u53F0\u7063 (\u7E41\u9AD4\u4E2D\u6587)"))))));
  }
}
exports.default = SiteSelector;
SiteSelector.propTypes = {
  lang: _propTypes.default.string,
  expanded: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};
SiteSelector.defaultProps = {
  lang: 'en-us',
  expanded: false
};